"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationDynamicCodeForResetTradePwdRequest = void 0;
var VerificationDynamicCodeForResetTradePwdRequest = /** @class */ (function () {
    function VerificationDynamicCodeForResetTradePwdRequest() {
    }
    return VerificationDynamicCodeForResetTradePwdRequest;
}());
exports.VerificationDynamicCodeForResetTradePwdRequest = VerificationDynamicCodeForResetTradePwdRequest;
;
//# sourceMappingURL=verificationDynamicCodeForResetTradePwd.request.js.map